export const LYNX_STORAGE_KEYS = {
  user: 'user',
  kioskToken: 'kioskToken',
  // preserve bellowing setting in client storage
  lobbyId: 'lobbyId',
  lobbyTheme: 'lobbyTheme',
  lobbyTemplateId: 'lobbyTemplateId',
  locale: 'locale',
  account: 'account',
  faviconTitle: 'faviconTitle',
};
